// extracted by mini-css-extract-plugin
module.exports = {"rectangle2":"SearchBar_rectangle2__17Bsp","inputContainer":"SearchBar_inputContainer__hY9XM","icon":"SearchBar_icon__2ueOw"};